import { Injectable } from '@angular/core';
import { ListingPageId } from '../../store/listing-page-store.types';
import { ListingPageModel } from './listing-page-model.types';

@Injectable({ providedIn: 'root' })
export class ListingPageModelRegistry {
  readonly models: Map<ListingPageId, ListingPageModel> = new Map();

  add(pageId: ListingPageId, model: ListingPageModel): void {
    if (this.models.has(pageId)) {
      // eslint-disable-next-line no-console
      console.warn(`[ListingPageModelRegistry] Model for Page "${pageId}" already registered. Overwriting.`);
    }

    this.models.set(pageId, model);
  }

  get(pageId: ListingPageId): ListingPageModel | null {
    const model = this.models.get(pageId);
    if (!model) {
      console.error(`[ListingPageModelRegistry] No Model found for Page ID: "${pageId}".`);
    }
    return model ?? null;
  }
}
